import { devicePushPreferences } from "./devicePushPreferences";
import { fcmClient } from "./fcmClient";
import { pushApi } from "./pushApi";
import { createPushRegistrar } from "./pushRegistrar";

/** The app's single registrar: the provider drives it while signed in, sign-out calls release(). */
export const pushRegistrar = createPushRegistrar({
  client: fcmClient,
  api: pushApi,
  preferences: devicePushPreferences,
  readAuthToken: () => localStorage.getItem("token"),
});

export { fcmClient };
